import styled from "@emotion/styled";
import { formInstructions } from "theme/styles/mixins";

export const Instructions = styled.span`
  ${formInstructions}
  display: block;
  margin-block-end: 1em;
  margin-block-start: 0.5em;
`;
